module.exports = __webpack_public_path__ + "./images/6998d992a899218087a8689dd56b3eef.webp";